import { Position } from "@xyflow/react";
import { Wallet } from "lucide-react";
import { BaseHandle } from "../../components/base-handle";
import { BaseNode, BaseNodeContent } from "../../components/base-node";
import { WalletNotificationActionNodeProps } from "./types";
import { ContextualTipsTrigger } from "@babackapp/ui/components/contextual-tips";
import { useTranslation } from "react-i18next";

export const WALLET_NOTIFICATION_NODE_WIDTH = 250;
export const WALLET_NOTIFICATION_NODE_HEIGHT_ESTIMATION = 120;

export function WalletNotificationActionNodeEditor({
  id,
}: WalletNotificationActionNodeProps) {
  const { t } = useTranslation("trackoffice");

  return (
    <ContextualTipsTrigger
      tips={[
        {
          id: "workflow-node-wallet",
          Icon: Wallet,
          title: t(
            "workflowsEditor.tips.workflowNodeWallet.title",
            "This is a wallet notification action node",
          ),
          description: t(
            "workflowsEditor.tips.workflowNodeWallet.desc",
            "This node will send a notification to the customer's wallet (Apple Wallet or Google Wallet) with tracking information.",
          ),
        },
      ]}
    >
      <BaseNode nodeId={id} style={{ position: "relative" }}>
        <BaseNodeContent>
          <div className="flex flex-col gap-2 w-full">
            <div className="flex flex-col">
              <span className="text-xs text-muted-foreground">
                Notification
              </span>
              <span className="text-xs mt-1 font-semibold">Wallet Pass</span>
            </div>
          </div>
          <BaseHandle type="target" position={Position.Left} />
          <BaseHandle
            type="source"
            position={Position.Right}
            style={{ top: "50%", transform: "translateY(-50%)" }}
          />
        </BaseNodeContent>
      </BaseNode>
    </ContextualTipsTrigger>
  );
}
